import { Navigate } from '@sorare/routing';

import { NBA_PLAY_COMMON_MARKET } from '@sorare/core/src/constants/__generated__/routes';

const CommonMarketPage = () => {
  return <Navigate to={NBA_PLAY_COMMON_MARKET} replace />;
};
export default CommonMarketPage;
